export default "__VITE_ASSET__Cajuy4jH__"